import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

const EditBlog = () => {
  const { updateId } = useParams();
  const [blog, setBlog] = useState();

  useEffect(() => {
    fetch(`https://youtube-api-blog-site-server.vercel.app/update/${updateId}`)
      .then((res) => res.json())
      .then((data) => setBlog(data));
  }, [updateId]);

  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.target;
    const title = form.title.value;
    const img = form.image.value;
    const blogText = form.blogText.value;

    const updatedBlog = {
      title,
      img,
      blogText,
    };

    fetch(`https://youtube-api-blog-site-server.vercel.app/update/${updateId}`,{
        method: "PUT",
        headers: {
            'Content-Type' : "application/json"
        },
        body: JSON.stringify(updatedBlog)
    })
    .then(res => res.json())
    .then(data => {
        if (data.modifiedCount > 0) {
            alert("blog updated successfully!")
            setBlog(updatedBlog);
        }
    })

  };

  return (
    <div>
      {/* blog update from label */}

      <div>
        <div className="container card md:w-2/3 mx-auto text-black shadow-xl m-10">
          <div className="card-body">
            <div className="card-actions justify-between">
              <label htmlFor="my-modal-3" className="">
                <div className="btn btn-outline md:btn-md btn-sm gap-2 text-black">
                  Edit
                  <div className="badge bg-blue-700 badge-outline">✏️</div>
                </div>
              </label>
              <Link to={"/blogs"} className="btn btn-square btn-sm">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </Link>
            </div>
            <div className="flex flex-col justify-center items-center">
              <img
                className="w-[400px] h-[225px] rounded-lg"
                src={blog?.img}
                alt=""
              />
              <h1 className="text-3xl font-bold mb-3 mt-5">{blog?.title}</h1>
              <p className="text-xl">{blog?.blogText}</p>
            </div>
          </div>
        </div>
      </div>

      {/*blog update form */}
      <input type="checkbox" id="my-modal-3" className="modal-toggle" />
      <div className="modal">
        <div className="modal-box relative">
          <label
            htmlFor="my-modal-3"
            className="btn btn-sm btn-circle absolute right-2 top-2"
          >
            ✕
          </label>
          <h3 className="text-lg font-bold text-center">
            Update {blog?.title}
          </h3>
          <form onSubmit={handleSubmit}>
            <div className="flex gap-2  mt-5">
              <input
                defaultValue={blog?.title}
                type="text"
                name="title"
                placeholder="Your blog title..."
                className="input input-sm input-bordered input-accent w-full max-w-xs"
              />
              <input
                defaultValue={blog?.img}
                type="text"
                name="image"
                placeholder="blog cover image link(400x225)"
                className="input input-sm input-bordered input-accent w-full max-w-xs"
              />
            </div>
            <textarea
              defaultValue={blog?.blogText}
              name="blogText"
              className="textarea textarea-accent w-full h-48 py-4 mt-10 text-lg"
              placeholder="Let's Start...."
            ></textarea>
            <button type="submit" className="btn btn-accent btn-sm mt-3">
              <label htmlFor="my-modal-3">Update</label>
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditBlog;
